var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMHat1NewHair1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "new-hair3_1_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D0E09B",
    d: "M519,189c-0.1-0.9,0.1-1.9,0-2.5c-10-83.3-101.5-94.6-149.2-96C319.9,89,226.2,106,205.3,173.8h-0.1 c-0.2,0.8-0.4,1.7-0.6,2.5c-0.6,2.3-1.2,4.7-1.7,7.2c-9.1,41.6-9.1,95.1-1.7,130.3c4.7-36.7,12.8-135.3,60-132.7l-23.8-3.1 c5.1-4.4,10.3-8.8,16-12.2c46.4-28.4,103-30,155.3-21.8c25,3.9,50.5,12.5,73.1,23.8c4.9,2.4,9.1,6.5,12.9,11.1l-33.1,6.6 c11.7,6,22.6,20.1,25.5,23.5c18,20.5,26.5,87.5,24,132C516.7,317.9,525.8,224,519,189z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "hats_new-hair3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m-hat1_8_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DC202F",
    d: "M502,188.4l-0.6-17.3c-1-15.8-0.4-18.6-7.1-21c-1.3-0.4-2.5-0.9-3.8-1.3c-18.8-6.4-38.3-11.2-58.3-14.4 c-3.6-0.6-7.1-1.1-10.7-1.6c-29.2-5.2-59.2-7.8-89.6-7.1c-3.8,0.1-7.6,0.2-11.4,0.4c-33.1,1.8-65.9,7-96.1,18.1 c-1.4,0.5-2.8,1-4.2,1.6c-3.1,1.2-10.9-0.2-5.4,48.3l0.1,3.5c1.3,9.7,6,11.5,10.8,9.9c0.4-0.1,0.7-0.2,1.1-0.4 c2-0.6,4.1-1.2,6.1-1.8c14.9-4.1,30.1-7.1,45.6-9.2c7.7-1.1,15.5-1.9,23.4-2.6c36.9-2.6,73.4-2.2,109.4,1.8 c7.2,0.8,14.3,1.7,21.5,2.8c14,2.2,27.7,5.2,41.2,9C487.8,211.1,503.4,218.6,502,188.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DC202F",
    d: "M331.9,125.7c30.4-0.6,60.4,2,89.6,7.1c3.6,0.5,7.1,1,10.7,1.6c20,3.2,39.6,7.9,58.3,14.4 c0.2-2.6,0.3-5.3,0.2-7.9c0-3.4-0.3-6.7-0.7-10c-2.8-24.4-14.5-49.9-35.3-67.5c-3-2.5-6.1-4.9-9.5-7c-17.7-12-39.2-16.9-61.5-18.4 c-3.7-0.2-7.4-0.4-11.2-0.5c-39.5-0.1-83.2,3.4-113,27.6c-3.1,2.4-6.1,4.9-8.8,7.5c-19.8,19.4-27.5,45.6-26.5,71.6 c30.2-11.1,63-16.2,96.1-18.1C324.3,125.9,328.1,125.7,331.9,125.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BA191F",
    d: "M485.8,144.1c-2.6-1.1-5.2-2.1-7.8-3.2c-17.4-6.8-35.5-12.3-54.1-16.6c-3.7-0.9-7.5-1.7-11.2-2.4 c-41.3-8.4-83.8-9.9-125.6-5.7c-3.8,0.4-7.5,0.9-11.3,1.4c-7.4,1.1-14.8,2.5-22,4.4c3.9-31.5,23.9-61.2,54.5-78.9 c0.2-0.1,0.3-0.2,0.5-0.3c-18.2,4-35.1,10.8-49.1,22.1c-3.1,2.4-6.1,4.9-8.8,7.5c-19.8,19.4-27.5,45.6-26.5,71.6 c30.2-11.1,63-16.2,96.1-18.1c3.8-0.2,7.6-0.3,11.4-0.4c30.4-0.6,60.4,2,89.6,7.1c3.6,0.5,7.1,1,10.7,1.6 c20,3.2,39.6,7.9,58.3,14.4c0.1-0.8,0.1-1.7,0.1-2.5C489,145.5,487.4,144.8,485.8,144.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BA191F",
    d: "M243.8,183c7.1-14.5,15.3-29.7,8.9-47.5c-9.6,2.3-19,5.2-28.2,8.5c-1.4,0.5-2.8,1-4.2,1.6 c-3.1,1.2-10.9-0.2-5.4,48.3l0.1,3.5c1.3,9.7,6,11.5,10.8,9.9c0.4-0.1,0.7-0.2,1.1-0.4c2-0.6,4.1-1.2,6.1-1.8 c5.1-1.4,10.1-2.6,15.3-3.8C245.3,195.4,241.5,188.6,243.8,183z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M362.8,26.7c-12-6.6-26.2,1.4-28.8,12.3c11.6-1.1,23.4-1.5,34.9-1.6C368.2,33.3,367.1,29,362.8,26.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M319.7,129.4c3.8-0.2,7.6-0.3,11.4-0.4c30.4-0.6,60.4,2,89.6,7.1c3.6,0.5,7.1,1,10.7,1.6 c23.7,3.8,46.8,9.7,68.6,18.1c-0.8-3.2-2.3-4.5-5.7-5.7c-1.3-0.4-2.5-0.9-3.8-1.3c-6.9-2.4-13.9-4.5-21-6.4l-0.3-7.3 c-3.5-31.9-16.3-59-41.3-82c24.8,23.4,35.2,50.9,38.5,82.2l0.3,6.4c-11.3-2.9-22.7-5.3-34.3-7.2l-0.7-6.8 C427.6,97.2,417.3,72,400.2,46c16.8,26.3,24.8,51.9,28.7,81.9l0.6,6.1c-2.7-0.4-5.3-0.8-8-1.2c-10.1-1.8-20.4-3.3-30.7-4.4 l-0.3-6.3c-1.4-28-2.9-52.3-13.2-78.6c9.9,26.4,9.1,50.7,10.4,78.6l0.3,5.9c-10.6-1.1-21.3-1.9-32.1-2.2l0.1-6 c0.1-26.9-2.2-49.7-6.3-75.7c3.7,26.1,3.7,48.9,3.5,75.7l-0.1,5.9c-7-0.2-14.1-0.2-21.2-0.1c-3.8,0.1-7.6,0.2-11.4,0.4 c-1.5,0.1-2.9,0.2-4.4,0.3l-0.4-5.4c-1.7-26.6-1.6-50.1,10-74.7c-11.9,24.3-14.3,48-12.7,74.8c0.1,1.9,0.3,3.7,0.4,5.5 c-11.7,0.8-23.3,2.1-34.8,3.9c-0.3-1.7-0.7-3.5-0.8-5.2c-2.5-24.9,1.3-46.9,12.3-69.7c-11.4,22.6-17.5,44.4-15.1,69.9 c0.2,1.8,0.5,3.6,0.9,5.4c-7.8,1.3-15.5,2.9-23.2,4.7c-0.2-1.5-0.5-3.1-0.5-4.6c-1.5-22.9,2.9-42.7,11.2-64.1 c-8.7,21.3-15.4,40.8-14,64.3c0.1,1.8,0.4,3.5,0.6,5.2c-8.7,2.2-17.2,4.8-25.5,7.8c-1.4,0.5-2.8,1-4.2,1.6s-3.9,0.5-5.6,5.2 c3.3-1.4,6.6-2.6,9.9-3.8C254.5,136.2,286.9,131.1,319.7,129.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M411.7,191.4c-36-4-72.6-4.4-109.4-1.8c-7.9,0.6-15.7,1.5-23.4,2.6c-15.5,2.1-30.6,5.1-45.6,9.2 c-2.4,0.7-4.8,1.4-7.2,2.1c-2.6,0.8-5.2,1.7-7.7,2.7c2,1.9,4.6,2.1,7.3,1.3c0.4-0.1,0.7-0.2,1.1-0.4c2-0.6,4.1-1.2,6.1-1.8 c14.9-4.1,30.1-7.1,45.6-9.2c7.7-1.1,15.5-1.9,23.4-2.6c36.9-2.6,73.4-2.2,109.4,1.8c7.2,0.8,14.3,1.7,21.5,2.8 c14,2.2,27.7,5.2,41.2,9c7.8,2.2,16,5.5,21.6,2.8c-20-7.1-40.9-12.3-62.3-15.7C426,193.1,418.9,192.1,411.7,191.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M243.1,196c-7.1-16.7-5.6-31.9-4.5-48.5c-0.6,16.7,1.4,31.6,8.3,47.2l2,4.2l-3.7,1.4L243.1,196z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M269.8,190.8c-5.7-17-6.6-32.3-4-49.1c-2,17,2.3,31.8,7.9,48.1c0.5,1.5,1.2,2.9,1.8,4.3l-3.8,1.2 C271,193.8,270.3,192.3,269.8,190.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M300.7,187.1c-4-17.3-5.4-32.5-4.5-49.6c-0.3,17.2,4.4,31.8,8.5,48.9l1.2,4.6l-4,0.7L300.7,187.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M334.3,185.3c-3.3-17.8-1.2-33.1,1.6-50.1c-2.3,17.2-0.9,32.4,2.4,49.6l1,4.6l-4,0.7L334.3,185.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M369.3,185.2c3.2-17.5,5.8-32.7,3.9-50.3c2.5,17.4,3.3,32.9,0.2,50.8l-0.9,4.8l-4-0.6L369.3,185.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M408,188.5c4.5-17.1,6.6-32.4,3-49.7c4.2,17,5.5,32.7,1,50.5l-1.4,4.7l-3.9-1L408,188.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M445.9,194.4c3-16.3,4.5-30.8,1.2-47.1c3.9,16.1,5.8,30.8,2.9,47.7l-0.9,4.5l-4-0.7L445.9,194.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M473.2,200c3.9-15.8,7-29.7,5.7-45.8c1.9,16,2.2,30.3-1.7,46.6l-1.2,4.3l-4-0.9L473.2,200z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M311.2,50.5c-0.4,1.6-1.5,2.8-2.4,2.6s-1.4-1.6-1-3.2c0.4-1.6,1.5-2.8,2.4-2.6 C311.1,47.4,311.6,48.9,311.2,50.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M301.4,74.7c-0.3,1.3-1.2,2.3-2,2.2s-1.2-1.3-0.9-2.7c0.3-1.3,1.2-2.3,2-2.2 C301.3,72.2,301.7,73.4,301.4,74.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M264.1,103.7c-0.3,1.3-1.2,2.3-2,2.2c-0.8-0.1-1.2-1.3-0.9-2.7c0.3-1.3,1.2-2.3,2-2.2 C264,101.2,264.4,102.4,264.1,103.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M257.6,182c0,1.4-0.6,2.5-1.4,2.5c-0.8,0-1.5-1.1-1.5-2.4c0-1.4,0.6-2.5,1.4-2.5 C256.9,179.5,257.6,180.6,257.6,182z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M286.9,141.4c0,1.6-0.7,3-1.7,3s-1.8-1.3-1.8-2.9c0-1.6,0.7-2.9,1.7-3 C286.1,138.5,286.9,139.8,286.9,141.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M283.8,179.8c0.4,1.6-0.1,3-1,3.2s-2-1-2.4-2.6s0.1-3,1-3.2C282.4,177,283.5,178.2,283.8,179.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M315.6,161.8c0.3,1.6-0.3,3-1.2,3.1c-1,0.1-1.9-1.1-2.2-2.7c-0.3-1.6,0.3-3,1.2-3.1 C314.4,159,315.4,160.2,315.6,161.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M326.8,136c-0.1,1.6-0.9,2.9-1.8,2.9c-1,0-1.7-1.4-1.6-3s0.9-2.9,1.8-2.9 C326.1,133,326.9,134.4,326.8,136z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M354.2,139.8c0,1.6-0.9,2.9-1.8,2.9c-1,0-1.7-1.4-1.6-3s0.9-2.9,1.8-2.9S354.3,138.2,354.2,139.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M349.4,177.1c0,1.6-0.9,2.9-1.8,2.9c-1,0-1.7-1.4-1.6-3s0.9-2.9,1.8-2.9 C348.7,174.2,349.5,175.5,349.4,177.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M391,151.9c-0.1,1.6-0.9,2.9-1.8,2.9c-1,0-1.7-1.4-1.6-3s0.9-2.9,1.8-2.9C390.3,149,391,150.3,391,151.9z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M395.1,180.3c-0.3,1.6-1.3,2.8-2.2,2.7c-1-0.1-1.5-1.5-1.2-3.1s1.3-2.8,2.2-2.7 C394.8,177.3,395.4,178.7,395.1,180.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M435,174.8c-0.3,1.6-1.3,2.8-2.2,2.7c-1-0.1-1.5-1.5-1.2-3.1s1.3-2.8,2.2-2.7S435.3,173.2,435,174.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M462.6,158c0,1.6-0.8,2.9-1.8,2.9s-1.7-1.3-1.7-3s0.8-2.9,1.8-2.9S462.6,156.4,462.6,158z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M464.6,190.3c-0.2,1.6-1.1,2.9-2,2.8c-1-0.1-1.6-1.4-1.5-3.1c0.2-1.6,1.1-2.9,2-2.8 C464.1,187.3,464.8,188.7,464.6,190.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M490.8,161.6c0,2-1,3.6-2.2,3.6s-2.1-1.7-2.1-3.7s1-3.6,2.2-3.6C489.9,157.9,490.8,159.6,490.8,161.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M293.3,103.5c-0.3,1.4-1.1,2.5-2,2.4c-0.8-0.1-1.3-1.3-1.1-2.8c0.3-1.4,1.1-2.5,2-2.4 C293.1,100.9,293.6,102.1,293.3,103.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4AAAB",
    d: "M274.3,66c-0.8,1.7-2.3,2.8-3.3,2.4c-1-0.3-1.1-2-0.3-3.7c0.8-1.7,2.3-2.8,3.3-2.4S275.1,64.3,274.3,66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4AAAB",
    d: "M245.1,102.5c-0.5,1.8-1.8,3-2.8,2.8s-1.5-1.8-1-3.6c0.5-1.8,1.8-3,2.8-2.8 C245.2,99.1,245.6,100.7,245.1,102.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4AAAB",
    d: "M237.1,125.2c-0.1,1.8-1,3.3-2.1,3.2c-1.1,0-1.9-1.5-1.8-3.4c0.1-1.8,1-3.3,2.1-3.2 C236.3,121.8,237.1,123.3,237.1,125.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4AAAB",
    d: "M226.7,173.4c-0.1,1.8-1,3.3-2.1,3.2c-1.1,0-1.9-1.5-1.8-3.4c0.1-1.8,1-3.3,2.1-3.2 S226.8,171.6,226.7,173.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4AAAB",
    d: "M251.7,156.4c-0.1,1.6-0.9,2.9-1.9,2.9s-1.7-1.4-1.6-3c0.1-1.6,0.9-2.9,1.9-2.9 C251,153.4,251.8,154.7,251.7,156.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4AAAB",
    d: "M227.2,196.9c0.3,1.4-0.1,2.7-0.9,2.8c-0.8,0.1-1.7-0.9-2-2.3c-0.3-1.4,0.1-2.7,0.9-2.8 C226,194.5,226.9,195.5,227.2,196.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M333.1,65.7c0,1.4-0.7,2.6-1.6,2.6s-1.6-1.2-1.6-2.6s0.7-2.6,1.6-2.6S333.1,64.3,333.1,65.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M330.5,104c0,1.4-0.8,2.6-1.7,2.5c-0.9,0-1.5-1.2-1.5-2.6s0.8-2.6,1.7-2.5 C329.9,101.3,330.6,102.5,330.5,104z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M366.8,64.3c0,1.4-0.8,2.6-1.7,2.5c-0.9,0-1.5-1.2-1.5-2.6s0.8-2.6,1.7-2.5 C366.1,61.7,366.8,62.9,366.8,64.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M369.7,86.3c-0.1,1.4-0.8,2.6-1.7,2.5c-0.9,0-1.5-1.2-1.5-2.6s0.8-2.6,1.7-2.5 C369.1,83.7,369.7,84.9,369.7,86.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M397.1,62.5c0.2,1.4-0.3,2.6-1.2,2.7c-0.9,0.1-1.7-1-1.9-2.4c-0.2-1.4,0.3-2.6,1.2-2.7 C396,60,396.9,61.1,397.1,62.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M405.1,106.3c0.2,1.4-0.3,2.6-1.2,2.7c-0.9,0.1-1.7-1-1.9-2.4c-0.2-1.4,0.3-2.6,1.2-2.7 C404,103.8,404.9,104.9,405.1,106.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M433,80.7c0.4,1.4,0.1,2.7-0.7,2.8s-1.9-0.8-2.3-2.2c-0.4-1.4-0.1-2.7,0.7-2.8 C431.5,78.3,432.6,79.3,433,80.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M449,114.6c0.4,1.4,0,2.7-0.8,2.8c-0.8,0.2-1.9-0.8-2.3-2.2c-0.4-1.4,0-2.7,0.8-2.8 C447.6,112.2,448.6,113.2,449,114.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M470.3,93.4c0.4,1.4,0,2.7-0.8,2.8c-0.8,0.2-1.9-0.8-2.3-2.2c-0.4-1.4,0-2.7,0.8-2.8 C468.9,91.1,469.9,92,470.3,93.4z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMHat1NewHair1);
export default __webpack_public_path__ + "static/media/m-hat1_new-hair1.5571daf09b78a0f8cfb1d2d3cbc1a885.svg";
export { ForwardRef as ReactComponent };